export default {
        srcSet: __webpack_public_path__ + "static/media/menu-item.eb130475.png"+" 248w",
        images: [{path: __webpack_public_path__ + "static/media/menu-item.eb130475.png",width: 248,height: 22}],
        src: __webpack_public_path__ + "static/media/menu-item.eb130475.png",
        toString: function(){return __webpack_public_path__ + "static/media/menu-item.eb130475.png"},
        placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAECAMAAADLTo0SAAAAJFBMVEXHQhN4Lg2tOhA9Igf/ZRnWTxXgWRbgVxbgWxbWTBTwWRjaUBYt7TX3AAAABHRSTlPkJsQb871RAQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADtJREFUeJyVikEOgDAQAretDqz+/7+Gi4mnRgLJBKhRkhAGhQxghGQ7mGWuGnXsdf073udXnXT8Nj3XA//eAw9bniOyAAAAAElFTkSuQmCC",
        width: 248,
        height: 22
      }